import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import { Tiles } from "./Tiles";
import {
  GLOBAL_SEARCH_QUERY_PARAM_KEY,
  SEARCH_RESULT_TAB_QUERY_PARAM_KEY,
  GLOBAL_SEARCH_RESULTS_SECTIONS,
} from "@/utils/constant";
import {
  analyticsClickEventAfterSearch,
  analyticsClickEventBeforeSearch,
} from "@/services/algolia/analytics";
import { RecipeType } from "@/utils/types/recipes";
import { ArticleType } from "@/utils/types/article";
import { Product } from "@/utils/types/product";
import OfferCard from "@/components/OfferCard";
 
const RenderResultsSection = ({
  type,
  title,
  query,
  queryIDs,
  data,
  setDropDown,
  className,
  index,
  userId,
  cta,
  addRecentSearch,
}: {
  type: "products" | "recipes" | "articles";
  title?: string;
  cta?: string;
  query: string;
  queryIDs: string;
  data: Product[] | RecipeType[] | ArticleType[];
  setDropDown: (flag: boolean) => void;
  className: string;
  index: string;
  userId?: string;
  addRecentSearch: (query: string) => void;
}) => {
  const viewAllCTATab = () => {
    switch (type) {
      case "recipes":
        return GLOBAL_SEARCH_RESULTS_SECTIONS.RECIPE;
      case "articles":
        return GLOBAL_SEARCH_RESULTS_SECTIONS.ARTICLE;
      default:
        return GLOBAL_SEARCH_RESULTS_SECTIONS.PRODUCT;
    }
  };
 
  return (
    <Box as="div">
      <Box as="div" className="flex justify-between items-center mb-[8px]">
        <Text as="h2" className="text-base font-bold leading-6">
          {title}
        </Text>
        <Link
          aria-label={`Click to view all ${type}`}
          className="font-bold px-[12px] text-sm 2xs:text-body py-[10px] text-[#003D2A]"
          href={`/?${GLOBAL_SEARCH_QUERY_PARAM_KEY}=${query}&${SEARCH_RESULT_TAB_QUERY_PARAM_KEY}=${viewAllCTATab()}`}
          onClick={() => {
            setDropDown(false);
            if (query) {
              addRecentSearch(query);
            }
          }}
        >
          {cta}
        </Link>
      </Box>
 
      <Box
        as="div"
        className={`mb-[2px] grid grid-cols-1 ${type === "products" ? "2xs:grid-cols-2  2md:grid-cols-3 lg:grid-cols-4  2xl:grid-cols-5 gap-[20px] [&_.card-title]:line-clamp-2" : "lgs:grid-cols-2 gap-[16px] max-w-[100%]"} ${type}-block`}
      >
        {data.map((item: Product | RecipeType | ArticleType, i) => {
          if (type === "products") {
            return (
              <Box
                key={item.objectID}
                as="div"
                onClick={() => setDropDown(false)}
              >
                <OfferCard
                  viewItemList={"Search - Products"}
                  viewItemListId={"7"}
                  isGlobalSearch={true}
                  item={item as Product}
                  showFavoriteButton={false}
                  showAddToCartButton={false}
                  query={query}
                />
              </Box>
            );
          } else {
            const recipeOrArticle = item as RecipeType | ArticleType;
            return (
              <Tiles
                key={recipeOrArticle.objectID}
                type={type}
                data={recipeOrArticle}
                className={className}
                query={query}
                onClick={() => {
                  if (query) {
                    analyticsClickEventAfterSearch({
                      kind: type,
                      index,
                      objectIDs: [item.objectID.toString()],
                      userToken: userId,
                      positions: [i + 1],
                      queryID: queryIDs,
                    });
                  } else {
                    analyticsClickEventBeforeSearch({
                      kind: type,
                      index,
                      objectIDs: [item.objectID.toString()],
                      userToken: userId,
                    });
                  }
 
                  setDropDown(false);
                }}
              />
            );
          }
        })}
      </Box>
    </Box>
  );
};
 
export default RenderResultsSection;
 
 